import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import About from './pages/About';
// import Blog from './pages/Blog';
// import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Labs from './pages/Labs';
import LabDetail from './pages/LabDetail';
import Licensing from './pages/Licensing';
import NotFound from './pages/NotFound';
import Work from './pages/Work';
import WorkDetail from './pages/WorkDetail';
import { trackPageView } from './analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

/** Track every route change as a GA4 page view */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageViewTracker />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/work/:slug" element={<WorkDetail />} />
          <Route path="/labs" element={<Labs />} />
          <Route path="/labs/:slug" element={<LabDetail />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/blog" element={<Blog />} /> */}
          {/* <Route path="/blog/:slug" element={<BlogDetail />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/licensing" element={<Licensing />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
